import { labels } from './sendings'

export default {
  title: 'Reenvíos',

  labels,

  errors: {
    onTimeout: {
      timeout: 'No puede ser menor que 10'
    }
  }
}
